import { AugmentedRealityType } from '../../../types/augmentedReality'
import {
  SCWelcomeButton,
  SCWelcomeContainer,
  SCWelcomeContent,
  SCWelcomeFramed,
  SCWelcomeImg,
  SCWelcomeImgContainer,
  SCWelcomeImgWrapper,
  SCWelcomeRibbon,
  SCWelcomeTitle,
} from 'components/AugmentedReality/Welcome/styled'
import { useTranslation } from 'react-i18next'

interface WelcomeFrameProps {
  ra: AugmentedRealityType;
  onNext: () => void;
  visited: boolean;
}
const WelcomeFrame = ({ ra, onNext, visited = false }: WelcomeFrameProps) => {
  const { t } = useTranslation();

  return (
    <SCWelcomeContainer>
      <SCWelcomeFramed $animationType={ra.welcome?.frameAnimation} $radius={ra.welcome.borderRadius} $borderWidth={ra.welcome.borderWidth}>
        <SCWelcomeContent>
          <SCWelcomeTitle>{ra.welcome.title}</SCWelcomeTitle>
          <SCWelcomeImgContainer>
            <SCWelcomeImgWrapper $radius={ra.welcome.borderRadius}>
              <SCWelcomeRibbon $visited={visited}>{t('augmentedReality.visited')}</SCWelcomeRibbon>
              <SCWelcomeImg
                src={ra.welcome.image}
                $radius={ra.welcome.borderRadius}
              />
            </SCWelcomeImgWrapper>
          </SCWelcomeImgContainer>
          <SCWelcomeImgContainer>
            <SCWelcomeButton onClick={onNext}>
              <label>{visited ? t('augmentedReality.seeAgain') : ra.welcome.button}</label>
            </SCWelcomeButton>
          </SCWelcomeImgContainer>
        </SCWelcomeContent>
      </SCWelcomeFramed>
    </SCWelcomeContainer>
  )
}
export default WelcomeFrame;